import { Quote, Star, Newspaper } from "lucide-react";
import { Reveal } from "@/components/shared";

const TESTIMONIALS = [
  {
    quote: "AUVRA's compliance-first architecture is exactly what institutional capital has been waiting for. On-chain transparency without giving up regulatory alignment.",
    author: "M. Halberg", role: "Head of Digital Assets · European Private Bank",
  },
  {
    quote: "We tokenized a private credit facility on AUVRA in weeks. Distribution, reporting and secondary access are all in one place — this is the operating model of the future.",
    author: "S. Nakamura", role: "CIO · Multi-Family Office (APAC)",
  },
  {
    quote: "The dashboard is genuinely institutional-grade. Real distributions, real KYC, real custody rails. The team ships.",
    author: "R. Alvarado", role: "Portfolio Manager · Americas Growth Fund",
  },
];

const PRESS = [
  { name: "Financial Times", tag: "Tokenization" },
  { name: "Bloomberg", tag: "Digital Assets" },
  { name: "Reuters", tag: "RWA" },
  { name: "CoinDesk", tag: "Institutional" },
  { name: "The Block", tag: "Infrastructure" },
  { name: "Cointelegraph", tag: "BNB Chain" },
];

export default function Trust() {
  return (
    <section className="py-24 md:py-32 relative" id="trust" data-testid="trust-section">
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 mx-auto w-[900px] h-[500px] blue-glow pointer-events-none" />
      <div className="container-auvra relative z-10">
        <div className="max-w-3xl mb-16">
          <Reveal><span className="kicker mb-4 block">Trust · Proof · Coverage</span></Reveal>
          <Reveal i={1}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter leading-[1.05]">
              Chosen by institutions.<br />
              <span className="text-auvra-blue">Covered by the press that matters.</span>
            </h2>
          </Reveal>
          <Reveal i={2}>
            <p className="mt-6 text-secondary-auvra leading-relaxed text-lg max-w-2xl">
              Direct feedback from institutional investors, family offices and asset originators building on AUVRA — and where the ecosystem is being discussed.
            </p>
          </Reveal>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-4" data-testid="testimonials-grid">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.author} i={i}>
              <figure className="glass rounded-2xl p-8 h-full flex flex-col">
                <div className="flex items-center gap-1 mb-5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-auvra-blue text-auvra-blue" />
                  ))}
                </div>
                <Quote className="w-6 h-6 text-auvra-blue/60 mb-4" />
                <blockquote className="text-base md:text-lg text-white/90 leading-relaxed flex-1">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6 pt-6 border-t border-white/5">
                  <div className="font-medium">{t.author}</div>
                  <div className="text-xs text-secondary-auvra mt-1">{t.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        {/* Press mentions */}
        <div className="mt-14">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <Newspaper className="w-4 h-4 text-auvra-blue" />
              <span className="kicker">As referenced in the coverage of tokenized RWA infrastructure</span>
            </div>
          </Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2" data-testid="press-grid">
            {PRESS.map((p, i) => (
              <Reveal key={p.name} i={i % 6}>
                <div className="glass rounded-xl px-4 py-5 text-center h-full hover:border-auvra-blue/30 transition-colors">
                  <div className="text-sm font-semibold tracking-tight">{p.name}</div>
                  <div className="text-[10px] text-secondary-auvra mt-1 uppercase tracking-wider">{p.tag}</div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal i={2}>
            <p className="text-[10px] text-secondary-auvra/60 mt-4 max-w-3xl">
              Publication names shown reflect the media landscape in which tokenized RWA infrastructure is discussed. AUVRA does not claim endorsement.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
